"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _CardModule = _interopRequireDefault(require("../styles/components/Card.module.css"));
var _ClearRounded = _interopRequireDefault(require("@mui/icons-material/ClearRounded"));
var _hooks = require("../hooks");
const _excluded = ["children", "showCloseBtn", "customIcon", "withHeader", "title", "titleTypographyProps", "sx", "className", "classNameCustomIcon", "theme", "onClose", "style", "animationSize"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const value = (v, def, theme) => theme[v] !== undefined ? theme[v] : def;
const CardWrap = (0, _material.styled)(_material.Card)(_ref => {
  let {
    theme = {}
  } = _ref;
  return {
    padding: value('padding', 15, theme),
    background: value('background', '#fff', theme),
    borderRadius: value('borderRadius', 10, theme),
    boxShadow: theme.boxShadow || '0 5px 15px rgb(0 0 0 / 10%)',
    textAlign: theme.text_align || '',
    '.MuiCardHeader-root': {
      padding: theme.padding_header || 0,
      paddingBottom: theme.paddingBottom_header || 15,
      paddingLeft: theme.paddingLeft_header || 5,
      '.MuiTypography-inherit': {
        color: theme.color || 'var(--main-color-cl-01)',
        fontWeight: theme.fontWeight || 'bold',
        fontSize: theme.fontSize || 18,
        height: theme.fontSize || 22
      }
    }
  };
});
const Card = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      children,
      showCloseBtn = false,
      customIcon,
      withHeader = true,
      title = '',
      titleTypographyProps = {
        variant: 'inherit',
        className: 'text_crop'
      },
      sx = {},
      className = '',
      classNameCustomIcon = '',
      // theme = { boxShadow: 'none' },
      theme = {},
      onClose = () => {},
      style = {},
      animationSize = false
    } = props,
    cardProps = _objectWithoutProperties(props, _excluded);
  const cardRef = (0, _react.useRef)(null);
  const rect = (0, _hooks.useResizeObserver)(cardRef);
  return /*#__PURE__*/_react.default.createElement(CardWrap, _extends({
    sx: sx,
    className: className,
    theme: theme
  }, cardProps, {
    ref: ref,
    style: animationSize ? _objectSpread({
      transition: ".2s",
      height: "calc(".concat(rect.height, "px + ").concat(value('padding', 15, theme) * 2, "px)"),
      width: "calc(".concat(rect.width, "px + ").concat(value('padding', 15, theme) * 2, "px)"),
      overflow: "hidden"
    }, style) : style
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ref: cardRef,
    className: _CardModule.default.box,
    style: animationSize ? {
      width: "fit-content",
      height: "fit-content"
    } : {}
  }, withHeader ? /*#__PURE__*/_react.default.createElement(_material.CardHeader, {
    action: showCloseBtn ? /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      "aria-label": "settings",
      className: _CardModule.default.card_header_btn,
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_ClearRounded.default, null)) : customIcon || null,
    titleTypographyProps: titleTypographyProps,
    title: title
  }) : customIcon ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "".concat(_CardModule.default.customIcon, " ").concat(classNameCustomIcon)
  }, customIcon) : null, children));
});
var _default = exports.default = Card;